import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { appConfig } from '../app.config';
import { Observable } from 'rxjs';
import { Cities, CitiesList, Countries, CountriesList } from './models/CountriesModel';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  config:any;
  apiUrl: string='';
  constructor(private apiService: CommonService) {
    this.config=appConfig
    this.apiUrl=appConfig.CountryServiceUrl;
   }

  getCountries(url: string):Observable<CountriesList> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-countries`, url) as Observable<CountriesList>;
    return this.apiService.response(data,CountriesList,'countries') as Observable<CountriesList>;
  }

  getCountriesById(url):Observable<Countries> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-countries`, url) as Observable<Countries>;
    return this.apiService.response(data,Countries,'countries') as Observable<Countries>;
  }

  getCities(url):Observable<CitiesList> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-cities`, url) as Observable<CitiesList>;
    return this.apiService.response(data,CitiesList,'cities') as Observable<CitiesList>;
  }

  getCitiesById(url):Observable<Cities> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-cities`, url) as Observable<Cities>;
    return this.apiService.response(data,Cities,'cities') as Observable<Cities>;
  }

  createCities(url,data):Observable<Cities> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-cities`, url,data) as Observable<Cities>;
  }
}
